/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-04-03 17:53:42
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { Button, Page } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import banner from 'src/assets/images/dashboard/newFeatureOnBoard/last-step-banner.png';
import { routes } from 'src/routes';
import history from 'src/routes/history';

class StepFive extends Component<Props> {
  render() {
    const { i18n } = this.props;
    return (
      <div className="BC-Page PFS-New-Feature-Onboard PFS-New-Feature-Onboard--five">
        <Page>
          <div>{i18n.translate(`AdminHTML.Dashboard.NewFeatureOnboard.step05_Title`)}</div>
          <img src={banner} alt="pfs-banner" />
          <div className="action-last-step">
            <Button
              onClick={() => {
                this.enableNewFeatureOnboarding('skip-onboard');

                history.push(routes.dashboard.view());
              }}>
              {i18n.translate(`AdminHTML.Dashboard.NewFeatureOnboard.step05_Action02`)}
            </Button>
            <Button
              primary
              onClick={() => {
                this.enableNewFeatureOnboarding('update-theme');
                history.push(routes.themeSetup.view());
              }}>
              {i18n.translate(`AdminHTML.Dashboard.NewFeatureOnboard.step05_Action01`)}
            </Button>
          </div>
        </Page>
      </div>
    );
  }

  enableNewFeatureOnboarding = action => {
    const { enableNewFeatureOnboarding, updateStep } = this.props;
    updateStep(5);
    enableNewFeatureOnboarding(true, 'finished-old-onboarding', action);
  };
}

export default withI18n()(StepFive);
